// extracted by mini-css-extract-plugin
module.exports = {"button":"KflSubCategoryCard_button__3lLZb","active":"KflSubCategoryCard_active__1yR51"};